import { Typography, Button } from "../../components"
import "./styles.css";

export default function QuickScan(props) {
    return (
        <div className="container">
            <iframe
                title="QuickScan NOLIA BabyFeeding"
                src="https://form.jotform.com/252923014180044"
                style={{
                width: "100%",
                height: "100vh",
                border: "none"
                }}
                allow="fullscreen; payment"
            ></iframe>
        </div>
  );
}